import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { IDImpediment } from 'civil-status/constants/id-impediment';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const typesData: Array<ItemVM> = [
  {
    id: IDImpediment.Sposo,
    value: 'Sposo',
  },
  {
    id: IDImpediment.Sposa,
    value: 'Sposa',
  },
  {
    id: IDImpediment.Entrambi,
    value: 'Entrambi',
  },
];

interface ListWifeHusbandProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  label: string;
  onChange: (value: SelectChangeEvent<string>) => void;
  error?: boolean;
  isSmallSize?: boolean;
}

const ListWifeHusbandComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  label,
}: ListWifeHusbandProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="type-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type"
        name="type"
        value={value}
        label={required ? `${label} *` : label}
        onChange={onChange}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {typesData?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListWifeHusbandComponent.displayName = 'List Wife Husband component';

const ListWifeHusband = memo(ListWifeHusbandComponent);

export default ListWifeHusband as typeof ListWifeHusbandComponent;
